import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Vue from "vue";

const ServiceRepository = RepositoryFactory.get('services');

const state = {
    selectedSite: null,
    selectedPublisher: [],
    siteDetails: null,
    siteDetailsLoading: false,
    previousTab: null,
    activeTab: 'Emergency_General',
    siteIsDisabled: null,
    externalIsEnabled: null,
    disabledSitetypes: [],
    disabledZones: [],
    loading: false,
    updated: 0, //Counter
};

// getters
const getters = {};

// actions
const actions = {
    async fetchTypesForEmergency({state, commit}) {
        state.loading = true;
        let {data} = await ServiceRepository.getTypesForEmergency(state.selectedSite.SiteId);
        if (data.Status) {
            state.siteDetails = data;
            commit('initState', data);
        }
        state.loading = false;
        return data;
    },
    async saveEmergency({commit}, payload) {
        let {data} = await ServiceRepository.saveEmergency(payload);
        try {
            if (data.Status) {
                commit('updateSiteDetailsAfterSave', payload);
                return data;
            }
        } catch (e) {
            return data;
        }
    },
    async saveEmergencyConfig({commit}, payload) {
        let {data} = await ServiceRepository.saveEmergencyConfig(payload);
        if (data.Status) {
            payload.Code = data.Code;
            commit('updateExternal', payload);
        }
        return data;
    },
};

// mutations
const mutations = {
    updateSelectedSite(state, payload) {
        state.selectedSite = payload;
    },
    updateActiveTab(state, payload) {
        if (state.activeTab !== null) {
            state.previousTab = state.activeTab;
        }
        state.activeTab = payload;
    },
    initState(state, data) {
        state.disabledSitetypes = [];
        state.disabledZones = [];
        state.siteIsDisabled = data.Site.SiteIsDisabled;
        state.externalIsEnabled = data.Site.ExternalIsEnabled;
        data.TypesAndZones.forEach((sitetype) => {
            if (sitetype.IsDisabled === 1) state.disabledSitetypes.push(sitetype.SitetypeId);
            sitetype.Zones.forEach((zone) => {
                if (zone.Status === 0) state.disabledZones.push(zone.ZoneId);
            })
        })
    },
    updateSiteIsDisabled(state, siteIsDisabled) {
        state.siteIsDisabled = siteIsDisabled;
    },
    updateExternalIsEnabled(state, externalIsEnabled) {
        state.externalIsEnabled = externalIsEnabled;
    },
    updateDisabledSitetypes(state, sitetype) {
        if (sitetype.IsDisabled === 1) {
            state.disabledSitetypes.push(sitetype.SitetypeId);
        } else {
            state.disabledSitetypes.splice(state.disabledSitetypes.findIndex(x => x === sitetype.SitetypeId), 1);
        }
    },
    updateDisabledZones(state, zone) {
        if (zone.Status === 0) {
            state.disabledZones.push(zone.ZoneId);
        } else {
            state.disabledZones.splice(state.disabledZones.findIndex(x => x === zone.ZoneId), 1);
        }
    },
    updateSiteDetailsAfterSave(state, data) {
        let siteDetails_copy = JSON.parse(JSON.stringify(state.siteDetails));
        siteDetails_copy.Site.IsDisabled = data.siteIsDisabled;
        siteDetails_copy.Site.ExternalIsEnabled = data.ExternalIsEnabled;

        setToDefault(siteDetails_copy);

        let config = {
            typeIsDisabled: data.typeIsDisabled,
            zoneIsDisabled: data.zoneIsDisabled
        }
        Object.keys(config).forEach((key) => {
            if (typeof data[key] !== "undefined") {
                let ids = Object.keys(config[key]);
                for (let i = 0; i < ids.length; i++) {
                    ids[i] = parseInt(ids[i]);
                }
                ids.forEach((id) => {
                    id = parseInt(id);
                    let index = null;
                    if (key === 'typeIsDisabled') {
                        index = siteDetails_copy.Types.findIndex(x => x.SitetypeId === id);
                        siteDetails_copy.Types[index].IsDisabled = 1;
                        siteDetails_copy.TypesAndZones[index].IsDisabled = 1;
                    } else if (key === 'zoneIsDisabled') { // bei zonen Status : 1 = aktiv/Toggle aus, 0 = deaktiviert/Toggle an
                        for (let i = 0; i < siteDetails_copy.TypesAndZones.length; i++) {
                            let siteype = siteDetails_copy.TypesAndZones[i];
                            for (let j = 0; j < siteype.Zones.length; j++) {
                                if (siteype.Zones[j].ZoneId === id) {
                                    siteype.Zones[j].Status = 0;
                                    break;
                                }
                            }
                        }
                    }
                });
            }
        });
        Vue.set(state, 'siteDetails', siteDetails_copy);

    },
    updateExternal(state, data) {
        state.selectedSite.ExternalIsEnabled = data.ExternalIsEnabled;
        state.selectedSite.ExternalCode = data.Code;
        state.selectedSite.ExternalIp = data.ExternalIp;
        state.selectedSite.ExternalMask = data.ExternalMask;
        state.siteDetails.Site.ExternalIsEnabled = data.ExternalIsEnabled;
        state.siteDetails.Site.ExternalCode = data.Code;
        state.siteDetails.Site.ExternalIp = data.ExternalIp;
        state.siteDetails.Site.ExternalMask = data.ExternalMask;
        state.updated++;
    },

    updateSelectedPublisher(state, {data}) {
        state.selectedPublisher = data;
    },
};

function setToDefault(obj) {
    for (let i = 0; i < obj.TypesAndZones.length; i++) {
        if (obj.Types[i].IsDisabled !== 0) {
            obj.Types[i].IsDisabled = 0;
            obj.TypesAndZones[i].IsDisabled = 0;
        }
        obj.TypesAndZones[i].Zones.forEach((zone) => {
            zone.Status = 1;
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}